import { faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./EmptyShowcase.scss"

export const EmptyShowcase = () => {
    return (
        <div className="emptyshowcase">
            <i class="emptyshowcase__icon far fa-smile"></i>
            <h2 className="emptyshowcase__subtitle">
                Welcome!
            </h2>
            <p className="emptyshowcase__message">
                <span>Please, select a item from the list. </span>
                <FontAwesomeIcon icon={faArrowUp} />
            </p>
        </div>
    )
}